module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_4-6e2971b919ade13c7b424b94b21fc65d.jpg";